<template>
    <section class="sites-carousel" v-if="sites && sites.length > 0">
        <div class="component-header container hd-container">
            <h2 class="headline-1"><NuxtLink :to="url">{{ title }}</NuxtLink></h2>
            <NuxtLink :to="url" class="view-all">View All</NuxtLink>
        </div>
        <div class="hd-container">
            <GlobalCarousel padding="20%" :items="sites">
                <template #item="item">
                    <!-- This carousel's card is much narrower than the same
                         card on an event page, so it passes its own measured
                         ladder rather than taking the shared `large` one. -->
                    <CardsSite :item="item" :type="type" :sizes="SIZES_SITE_CARD_CAROUSEL" />
                </template>
            </GlobalCarousel>
        </div>
    </section>
</template>

<script setup>
    // Props
    const props = defineProps({
        sites: {
            type: Object,
            required: true,
            default: {},
        },
        type: {
            type: String,
            required: true,
            default: 'large',
        },
        // Defaults to the bare noun so the archive routes this component still
        // handles (see `url` below) don't end up labelled with a year they are
        // not showing. The homepages pass the festival year explicitly.
        title: {
            type: String,
            required: false,
            default: 'Sites',
        },
    });
    const { sites, type, title } = toRefs(props);

    const route = useRoute();
    const url = computed(() => {
        if (route.path.includes('archive')) return '/archive/2023/sites/';
        else return '/sites/';
    });
</script>

<style lang="scss" scoped>
    .sites-carousel {
        padding: 0 0 30px 0;
    }
</style>
